export const ActionTypes = {
  REQUEST: "ADMIN_FETCH_HM_USER_REQUEST",
  SUCCESS: "ADMIN_FETCH_HM_USER_SUCCESS",
  FAILURE: "ADMIN_FETCH_HM_USER_FAILURE",

  UPDATE_REQUEST: "ADMIN_UPDATE_HM_USER_REQUEST",
  UPDATE_SUCCESS: "ADMIN_UPDATE_HM_USER_SUCCESS",
  UPDATE_FAILURE: "ADMIN_UPDATE_HM_USER_FAILURE",
}

export interface IAdminHmUser {
  id: string;
  password: string,
  last_login: null | string,
  is_superuser: boolean,
  first_name: string,
  last_name: string,
  is_staff: boolean,
  is_active: boolean,
  date_joined: null | string,
  email: string,
  name: string,
  username: string,
  phone: string | null,
  profile_picture: null | string,
  external_profile_picture: null | string,
}

export interface IAdminHmUserState {
  data: IAdminHmUser | null;
  loading: boolean;
  loading_update: boolean;
}
